import { styled } from '@mui/material/styles'

/** Makes this the preferred line break point with inline-block. */
export const OptionalBreak = styled('span')({
  display: 'inline-block',
})
